import { render, staticRenderFns } from "./InternetPlansNew.vue?vue&type=template&id=01c230bc&scoped=true&"
import script from "./InternetPlansNew.vue?vue&type=script&lang=js&"
export * from "./InternetPlansNew.vue?vue&type=script&lang=js&"
import style0 from "./InternetPlansNew.vue?vue&type=style&index=0&id=01c230bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c230bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VDivider,VImg,VRow,VTextField,VTextarea})
